import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1485553702922160');
    window.fbq('track', 'PageView');
  }, []);
  const handleCtaClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  };
  return <div className="font-['Georgia',serif] bg-[#fff8f5] text-[#2d2d2d] leading-[1.8] min-h-screen" data-id="element-0">
      {/* HERO SECTION */}
      <section className="bg-gradient-to-br from-[#f9c6c6] via-[#fde8d8] to-[#fce4ec] text-center pt-[60px] px-[20px] pb-[40px] border-b-[4px] border-[#e57373]" data-id="element-1">
        <div className="inline-block bg-[#e53935] text-white text-[12px] font-bold tracking-[2px] uppercase py-[6px] px-[18px] rounded-[20px] mb-[20px]" data-id="element-2">
          🔥 Revelación Exclusiva Para Mujeres
        </div>
        <h1 className="text-[clamp(26px,5vw,48px)] text-[#b71c1c] leading-[1.3] max-w-[800px] mx-auto mb-[16px] drop-shadow-[1px_1px_2px_rgba(0,0,0,0.1)]" data-id="element-3">
          Descubre El{' '}
          <span className="text-[#c62828] italic underline" data-id="element-4">
            Disparador Secreto
          </span>
          <br data-id="element-5" />
          Que Todo Hombre Ansía
          <br data-id="element-6" />
          ¡Y Que Lo Hará Perder La Cabeza Por Ti!
        </h1>
        <p className="text-[18px] text-[#5d3a3a] max-w-[600px] mx-auto mb-[30px]" data-id="element-7">
          El 99% de las mujeres ignora este impulso primario que convierte a
          cualquier hombre en alguien completamente devoto y loco por ti.
        </p>

        <div className="relative max-w-[560px] mx-auto mt-[10px]" data-id="element-8">
          <div className="absolute -inset-[6px] bg-gradient-to-br from-[#e91e63] via-[#ff7043] to-[#ffcc02] rounded-[20px] blur-[2px] opacity-70" data-id="element-9"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5VN5CqENc5adoEX1HK3br7/Pareja.png" alt="Pareja conectando con miradas íntimas en una cena romántica" className="relative w-full h-auto rounded-[16px] shadow-[0_12px_40px_rgba(0,0,0,0.25)] block" data-id="element-10" />
          <div className="absolute bottom-[14px] left-[14px] right-[14px] bg-gradient-to-t from-black/70 to-transparent rounded-b-[16px] pt-[40px] pb-[14px] px-[18px] pointer-events-none" data-id="element-11">
            <p className="text-white text-[14px] font-bold tracking-[0.5px] m-0 drop-shadow-md" data-id="element-12">
              💞 Cuando él te mira así... sabes que has activado{' '}
              <span className="text-[#ffcc02]" data-id="element-13">el disparador secreto.</span>
            </p>
          </div>
        </div>
      </section>

      {/* STORY SECTION */}
      <section className="max-w-[760px] mx-auto py-[60px] px-[24px]" data-id="element-14">
        <p className="text-[17px] text-[#3e2723] mb-[20px]" data-id="element-15">
          Mi teléfono vibró sobre la mesa de mi oficina... y era un mensaje de
          él. Mis manos temblaban mientras lo tomaba para leer lo que acababa de
          enviar... y <strong data-id="element-16">mi mundo se vino abajo.</strong>
        </p>
        <div className="bg-[#fce4ec] border-[2px] border-dashed border-[#e91e63] rounded-[12px] py-[24px] px-[28px] my-[30px] text-center" data-id="element-17">
          <p className="text-[22px] font-bold text-[#880e4f] m-0" data-id="element-18">
            "Terminamos."
          </p>
        </div>
        <p className="text-[17px] text-[#3e2723] mb-[20px]" data-id="element-19">
          Solté el teléfono y la pantalla se estrelló contra la mesa. Mi mente
          no dejaba de dar vueltas buscando razones...
          <em data-id="element-20">¿Por qué me dejaba tan de repente?</em>
        </p>
        <p className="text-[17px] text-[#3e2723] mb-[20px]" data-id="element-21">
          ¿Era por la chica nueva de la oficina? ¿No lo había tratado bien? ¿Se
          cansó de mí? ¿Ya no soy lo suficientemente atractiva para él?
        </p>
        <p className="text-[17px] text-[#3e2723] mb-[20px]" data-id="element-22">
          Por más que intenté, no pude contener las lágrimas... hasta que
          recordé
          <strong data-id="element-23"> la obsesión secreta</strong> que una amiga me enseñó después
          de una revelación impactante.
        </p>
        <p className="bg-[#fff3e0] border-l-[5px] border-[#ff7043] py-[16px] px-[20px] rounded-[8px] italic text-[18px] text-[#bf360c] mb-[20px]" data-id="element-24">
          "Un método extraño y simple que haría que su corazón ardiera con un
          deseo intoxicante cada vez que pensara en mí... como si hubiera
          lanzado un hechizo de amor hipnótico sobre él."
        </p>
        <p className="text-[17px] text-[#3e2723] mb-[20px]" data-id="element-25">
          Este secreto revela lo que puede hacer que un hombre{' '}
          <strong data-id="element-26">olvide a cualquier otra mujer</strong> y enfoque toda su
          atención, amor y deseo en ti, y <em data-id="element-27">solo en ti.</em>
        </p>
        <div className="bg-[#fce4ec] border-[2px] border-dashed border-[#e91e63] rounded-[12px] py-[24px] px-[28px] my-[30px] text-center" data-id="element-28">
          <p className="text-[22px] font-bold text-[#880e4f] m-0" data-id="element-29">
            Para convertirte en la ÚNICA mujer que él tenga en su mente...
            <br data-id="element-30" />
            y hacer que te adore, fantasee contigo y se obsesione
            <br data-id="element-31" />
            como si fueras la última mujer sobre la Tierra. 💫
          </p>
        </div>
      </section>

      {/* SECRET SECTION */}
      <section className="bg-gradient-to-b from-[#1a237e] to-[#283593] text-white py-[60px] px-[24px] text-center" data-id="element-32">
        <h2 className="text-[clamp(22px,4vw,38px)] text-[#ffcc02] mb-[20px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)]" data-id="element-33">
          ⚡ El Secreto que el 99% de las Mujeres Ignora
        </h2>
        <div className="w-[80px] h-[4px] bg-gradient-to-r from-[#ffcc02] to-[#ff7043] rounded-[4px] mx-auto mb-[30px]" data-id="element-34"></div>
        <p className="text-[17px] max-w-[700px] mx-auto mb-[20px] text-[#e8eaf6] leading-[1.9]" data-id="element-35">
          Existe algo que todos los hombres desean secretamente. Es algo que
          anhelan más que el amor, más que el dinero, incluso{' '}
          <strong data-id="element-36">más que el sexo.</strong>
        </p>
        <p className="text-[17px] max-w-[700px] mx-auto mb-[20px] text-[#e8eaf6] leading-[1.9]" data-id="element-37">
          Este impulso está tan programado en la mente masculina que controla
          subconscientemente todo lo que hace desde que se despierta hasta que
          se acuesta.
        </p>
        <a href="#acceder-ahora" className="inline-block bg-[#ffcc02] text-[#1a237e] text-[28px] font-bold py-[16px] px-[40px] rounded-[50px] my-[20px] tracking-[1px] shadow-[0_6px_24px_rgba(255,204,2,0.4)] no-underline cursor-pointer transition-transform duration-200 hover:scale-105" data-id="element-38">
          🦸 El "Instinto del Héroe"
        </a>
        <p className="text-[17px] max-w-[700px] mx-auto mb-[20px] text-[#e8eaf6] leading-[1.9]" data-id="element-39">
          Es el mayor secreto para convertirte en la máxima pasión y prioridad
          en la vida de un hombre.
        </p>
        <p className="text-[17px] max-w-[700px] mx-auto mb-[20px] text-[#e8eaf6] leading-[1.9]" data-id="element-40">
          No importa qué tan enamorado esté un hombre; si la mujer con la que
          está
          <strong data-id="element-41"> no activa su instinto del héroe</strong>, él siempre sentirá
          que algo falta y, eventualmente, buscará a otra mujer que sí lo haga.
        </p>
      </section>

      {/* FEATURES / SIGNALS */}
      <section className="max-w-[860px] mx-auto py-[60px] px-[24px]" data-id="element-42">
        <h2 className="text-center text-[clamp(22px,4vw,36px)] text-[#880e4f] mb-[40px] font-bold" data-id="element-43">
          🎯 Lo que aprenderás para transformar tu relación
        </h2>
        <div className="w-[80px] h-[4px] bg-gradient-to-r from-[#e91e63] to-[#ff7043] rounded-[4px] mx-auto mb-[30px]" data-id="element-44"></div>

        <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-[24px]" data-id="element-45">
          <div className="bg-white border border-[#f8bbd0] rounded-[16px] py-[28px] px-[24px] shadow-[0_4px_20px_rgba(233,30,99,0.08)] transition-all duration-200 hover:-translate-y-[4px] hover:shadow-[0_8px_32px_rgba(233,30,99,0.15)]" data-id="element-46">
            <div className="text-[36px] mb-[12px]" data-id="element-47">🤝</div>
            <h3 className="text-[18px] text-[#c62828] mb-[10px] font-bold" data-id="element-48">
              La "Señal I O U"
            </h3>
            <p className="text-[15px] text-[#555] leading-[1.7]" data-id="element-49">
              El mayor secreto de atracción que genera una confianza tan
              profunda que él te verá como su única confidente, abriéndose
              contigo antes que con sus mejores amigos.
            </p>
          </div>
          <div className="bg-white border border-[#f8bbd0] rounded-[16px] py-[28px] px-[24px] shadow-[0_4px_20px_rgba(233,30,99,0.08)] transition-all duration-200 hover:-translate-y-[4px] hover:shadow-[0_8px_32px_rgba(233,30,99,0.15)]" data-id="element-50">
            <div className="text-[36px] mb-[12px]" data-id="element-51">🛡️</div>
            <h3 className="text-[18px] text-[#c62828] mb-[10px] font-bold" data-id="element-52">
              La Señal de "Damisela en Apuros"
            </h3>
            <p className="text-[15px] text-[#555] leading-[1.7]" data-id="element-53">
              Cómo activar sus instintos naturales de protección para obtener su
              atención total cuando tú quieras — ideal si él está siempre
              distraído con su teléfono o se muestra distante.
            </p>
          </div>
          <div className="bg-white border border-[#f8bbd0] rounded-[16px] py-[28px] px-[24px] shadow-[0_4px_20px_rgba(233,30,99,0.08)] transition-all duration-200 hover:-translate-y-[4px] hover:shadow-[0_8px_32px_rgba(233,30,99,0.15)]" data-id="element-54">
            <div className="text-[36px] mb-[12px]" data-id="element-55">💌</div>
            <h3 className="text-[18px] text-[#c62828] mb-[10px] font-bold" data-id="element-56">
              La "Señal X-Back"
            </h3>
            <p className="text-[15px] text-[#555] leading-[1.7]" data-id="element-57">
              Si has pasado por una ruptura, estas{' '}
              <strong data-id="element-58">12 palabras poderosas</strong>
              reestructuran instantáneamente cómo él te imagina en su vida. Casi
              imposible de ignorar.
            </p>
          </div>
          <div className="bg-white border border-[#f8bbd0] rounded-[16px] py-[28px] px-[24px] shadow-[0_4px_20px_rgba(233,30,99,0.08)] transition-all duration-200 hover:-translate-y-[4px] hover:shadow-[0_8px_32px_rgba(233,30,99,0.15)]" data-id="element-59">
            <div className="text-[36px] mb-[12px]" data-id="element-60">🔍</div>
            <h3 className="text-[18px] text-[#c62828] mb-[10px] font-bold" data-id="element-61">
              La "Pregunta de Rayos X"
            </h3>
            <p className="text-[15px] text-[#555] leading-[1.7]" data-id="element-62">
              Una frase simple que te permite entrar en su mente y escuchar lo
              que él quisiera decirte pero no puede, revelando el botón
              emocional secreto de su corazón.
            </p>
          </div>
          <div className="bg-white border border-[#f8bbd0] rounded-[16px] py-[28px] px-[24px] shadow-[0_4px_20px_rgba(233,30,99,0.08)] transition-all duration-200 hover:-translate-y-[4px] hover:shadow-[0_8px_32px_rgba(233,30,99,0.15)]" data-id="element-63">
            <div className="text-[36px] mb-[12px]" data-id="element-64">🏝️</div>
            <h3 className="text-[18px] text-[#c62828] mb-[10px] font-bold" data-id="element-65">
              La "Señal de la Isla Privada"
            </h3>
            <p className="text-[15px] text-[#555] leading-[1.7]" data-id="element-66">
              La cualidad científicamente comprobada como el factor más
              importante para que un hombre decida <strong data-id="element-67">casarse</strong>
              con una mujer en específico.
            </p>
          </div>
          <div className="bg-white border border-[#f8bbd0] rounded-[16px] py-[28px] px-[24px] shadow-[0_4px_20px_rgba(233,30,99,0.08)] transition-all duration-200 hover:-translate-y-[4px] hover:shadow-[0_8px_32px_rgba(233,30,99,0.15)]" data-id="element-68">
            <div className="text-[36px] mb-[12px]" data-id="element-69">✨</div>
            <h3 className="text-[18px] text-[#c62828] mb-[10px] font-bold" data-id="element-70">
              ¿Para quién funciona?
            </h3>
            <p className="text-[15px] text-[#555] leading-[1.7]" data-id="element-71">
              Este sistema funciona incluso si tu hombre está perdiendo el
              interés, ha dejado de responder tus mensajes o sientes que la
              chispa se ha apagado por completo.
            </p>
          </div>
        </div>
      </section>

      {/* PROMISE BANNER */}
      <div className="bg-gradient-to-r from-[#e53935] to-[#e91e63] text-white text-center py-[40px] px-[24px]" data-id="element-72">
        <p className="text-[clamp(18px,3vw,26px)] font-bold max-w-[700px] mx-auto leading-[1.5]" data-id="element-73">
          💡 En el momento en que actives este disparador secreto, él sentirá
          una oleada de deseo que va mucho más allá de la atracción física.
          <br data-id="element-74" />
          Todas las demás mujeres desaparecerán de su mente.
        </p>
      </div>

      {/* STATS / COMPARISON TABLE */}
      <section className="max-w-[760px] mx-auto py-[50px] px-[24px]" data-id="element-75">
        <h2 className="text-center text-[28px] text-[#1a237e] mb-[30px] font-bold" data-id="element-76">
          📊 ¿Qué pasa cuando activas el Instinto del Héroe?
        </h2>
        <div className="overflow-x-auto rounded-[12px] shadow-[0_4px_24px_rgba(0,0,0,0.08)]" data-id="element-77">
          <table className="w-full border-collapse" data-id="element-78">
            <thead data-id="element-79">
              <tr className="bg-[#1a237e] text-[#ffcc02]" data-id="element-80">
                <th className="py-[16px] px-[20px] text-[15px] text-left tracking-[0.5px]" data-id="element-81">
                  Situación
                </th>
                <th className="py-[16px] px-[20px] text-[15px] text-left tracking-[0.5px]" data-id="element-82">
                  Sin el Método
                </th>
                <th className="py-[16px] px-[20px] text-[15px] text-left tracking-[0.5px]" data-id="element-83">
                  Con el Método
                </th>
              </tr>
            </thead>
            <tbody data-id="element-84">
              <tr className="bg-white" data-id="element-85">
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-86">
                  Él responde tus mensajes
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-87">
                  <span className="text-[#e53935] font-bold text-[18px]" data-id="element-88">
                    ✗
                  </span>{' '}
                  Tarda horas o ignora
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-89">
                  <span className="text-[#43a047] font-bold text-[18px]" data-id="element-90">
                    ✓
                  </span>{' '}
                  Responde de inmediato
                </td>
              </tr>
              <tr className="bg-[#e8eaf6]" data-id="element-91">
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-92">
                  Piensa en ti constantemente
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-93">
                  <span className="text-[#e53935] font-bold text-[18px]" data-id="element-94">
                    ✗
                  </span>{' '}
                  Te olvida fácilmente
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-95">
                  <span className="text-[#43a047] font-bold text-[18px]" data-id="element-96">
                    ✓
                  </span>{' '}
                  Tú eres su prioridad
                </td>
              </tr>
              <tr className="bg-white" data-id="element-97">
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-98">
                  Se abre emocionalmente
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-99">
                  <span className="text-[#e53935] font-bold text-[18px]" data-id="element-100">
                    ✗
                  </span>{' '}
                  Cerrado y distante
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-101">
                  <span className="text-[#43a047] font-bold text-[18px]" data-id="element-102">
                    ✓
                  </span>{' '}
                  Te cuenta todo
                </td>
              </tr>
              <tr className="bg-[#e8eaf6]" data-id="element-103">
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-104">
                  Interés en el compromiso
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-105">
                  <span className="text-[#e53935] font-bold text-[18px]" data-id="element-106">
                    ✗
                  </span>{' '}
                  Evita el tema
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-107">
                  <span className="text-[#43a047] font-bold text-[18px]" data-id="element-108">
                    ✓
                  </span>{' '}
                  Lo propone él mismo
                </td>
              </tr>
              <tr className="bg-white" data-id="element-109">
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-110">
                  Atracción y deseo
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-111">
                  <span className="text-[#e53935] font-bold text-[18px]" data-id="element-112">
                    ✗
                  </span>{' '}
                  La chispa se apagó
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-113">
                  <span className="text-[#43a047] font-bold text-[18px]" data-id="element-114">
                    ✓
                  </span>{' '}
                  Más fuerte que al inicio
                </td>
              </tr>
              <tr className="bg-[#e8eaf6]" data-id="element-115">
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-116">
                  Relaciones salvadas
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-117">
                  <span className="text-[#e53935] font-bold text-[18px]" data-id="element-118">
                    ✗
                  </span>{' '}
                  Ruptura inevitable
                </td>
                <td className="py-[14px] px-[20px] text-[15px] text-[#2d2d2d] border-b border-[#e0e0e0]" data-id="element-119">
                  <span className="text-[#43a047] font-bold text-[18px]" data-id="element-120">
                    ✓
                  </span>{' '}
                  +90% se recuperan
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="bg-[#fce4ec] py-[60px] px-[24px] text-center" data-id="element-121">
        <h2 className="text-[28px] text-[#880e4f] mb-[40px] font-bold" data-id="element-122">
          💬 Lo que dicen ellas...
        </h2>
        <div className="bg-white rounded-[16px] py-[32px] px-[28px] max-w-[600px] mx-auto shadow-[0_4px_24px_rgba(233,30,99,0.12)]" data-id="element-123">
          <div className="text-[#ffc107] text-[24px] mb-[16px]" data-id="element-124">★★★★★</div>
          <p className="text-[17px] italic text-[#4a148c] leading-[1.8] mb-[16px]" data-id="element-125">
            "Mi hombre está absolutamente loco por mí ahora, casi no puede tener
            suficiente... <em data-id="element-126">casi.</em> 😊 Espero sinceramente que estas
            señales te den todo lo que necesitas para construir la relación
            devota y duradera que mereces con el hombre que amas."
          </p>
          <span className="font-bold text-[#c62828] not-italic text-[15px]" data-id="element-127">
            — Helen ❤️
          </span>
        </div>
      </section>

      {/* CTA SECTION */}
      <section id="acceder-ahora" className="bg-gradient-to-br from-[#880e4f] to-[#c62828] text-white text-center py-[70px] px-[24px] scroll-mt-[20px]" data-id="element-128">
        <h2 className="text-[clamp(24px,4vw,42px)] mb-[20px] leading-[1.3] font-bold" data-id="element-129">
          Tu relación puede ser diferente.
          <br data-id="element-130" />
          Comienza hoy mismo. 🔑
        </h2>
        <p className="text-[18px] max-w-[600px] mx-auto mb-[36px] text-[#fce4ec] leading-[1.8]" data-id="element-131">
          Descubre las señales exactas que activan el Instinto del Héroe en
          cualquier hombre y transforma para siempre la forma en que él te ve,
          te desea y te ama.
        </p>

        {/* PRICE BOX */}
        <div className="inline-block bg-white/10 backdrop-blur-sm border-[2px] border-[#ffcc02] rounded-[16px] py-[20px] px-[36px] mb-[28px]" data-id="element-132">
          <div className="text-[14px] uppercase tracking-[2px] text-[#fce4ec] mb-[10px] font-bold" data-id="element-133">
            🎉 Oferta Por Tiempo Limitado
          </div>
          <div className="flex items-center justify-center gap-[14px]" data-id="element-134">
            <span className="text-[22px] text-[#f48fb1] line-through opacity-80" data-id="element-135">
              $27
            </span>
            <span className="text-[44px] font-bold text-[#ffcc02] leading-none" data-id="element-136">
              $6.39
            </span>
          </div>
          <div className="text-[13px] text-[#fce4ec] mt-[10px]" data-id="element-137">
            Pago único · Acceso inmediato · 76% de descuento
          </div>
        </div>
        <br data-id="element-138" />

        <a href="https://www.formacioninteligente.com/cart/44556980322439:1" target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="inline-block bg-[#ffcc02] text-[#1a237e] text-[22px] max-[600px]:text-[18px] font-bold py-[20px] px-[60px] max-[600px]:py-[16px] max-[600px]:px-[36px] rounded-[50px] no-underline tracking-[1px] uppercase shadow-[0_8px_32px_rgba(0,0,0,0.25)] transition-all duration-200 hover:scale-105 hover:shadow-[0_12px_40px_rgba(0,0,0,0.35)] animate-custom-pulse" data-id="element-139">
          🔥 ¡ACCEDER AHORA POR $6.39!
        </a>
        <p className="mt-[20px] text-[13px] text-[#f48fb1] tracking-[0.5px]" data-id="element-140">
          🔒 Acceso 100% seguro y privado · Resultados desde el primer uso
        </p>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#1a1a1a] text-[#aaa] text-center py-[30px] px-[20px] text-[13px]" data-id="element-141">
        <p className="mb-[16px]" data-id="element-142">
          <a href="#" className="text-[#f48fb1] no-underline hover:underline mx-[8px]" data-id="element-143">
            Privacidad
          </a>
          <a href="#" className="text-[#f48fb1] no-underline hover:underline mx-[8px]" data-id="element-144">
            Términos
          </a>
          <a href="#" className="text-[#f48fb1] no-underline hover:underline mx-[8px]" data-id="element-145">
            Ganancias
          </a>
          <a href="#" className="text-[#f48fb1] no-underline hover:underline mx-[8px]" data-id="element-146">
            Contacto
          </a>
          <a href="#" className="text-[#f48fb1] no-underline hover:underline mx-[8px]" data-id="element-147">
            DMCA
          </a>
        </p>
        <p className="text-[11px] text-[#666] max-w-[600px] mx-auto" data-id="element-148">
          Este sitio no está afiliado a Facebook ni a ninguna empresa de
          Facebook. Una vez que abandona Facebook, la responsabilidad de nuestra
          política de privacidad no aplica. © 2024 Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}